import axios from "axios";
const url = window.location.origin;
import SlimSelect from "slim-select";

const allCountry = [
  { placeholder: true, text: "Choose country" },
  { text: "Albania", code: "AL", value: "Albania" },
  { text: "Armenia", code: "AM", value: "Armenia" },
  { text: "Australia", code: "AU", value: "Australia" },
  { text: "Austria", code: "AT", value: "Austria" },
  { text: "Belgium", code: "BE", value: "Belgium" },
  { text: "Brazil", code: "BR", value: "Brazil" },
  { text: "Bulgaria", code: "BG", value: "Bulgaria" },
  { text: "Canada", code: "CA", value: "Canada" },
  { text: "Cayman Island", code: "KY", value: "Cayman Island" },
  { text: "China PRC", code: "CN", value: "China PRC" },
  { text: "Croatia", code: "HR", value: "Croatia" },
  { text: "Czech Republic", code: "CZ", value: "Czech Republic" },
  { text: "Denmark", code: "DK", value: "Denmark" },
  { text: "Faroe Islands", code: "FO", value: "Faroe Islands" },
  { text: "Finland", code: "FI", value: "Finland" },
  { text: "France", code: "FR", value: "France" },
  { text: "Germany", code: "DE", value: "Germany" },
  { text: "Greece", code: "GR", value: "Greece" },
  { text: "Hong Kong SAR", code: "HK", value: "Hong Kong SAR" },
  { text: "Hungary", code: "HU", value: "Hungary" },
  { text: "Iceland", code: "IS", value: "Iceland" },
  { text: "Ireland", code: "IE", value: "Ireland" },
  { text: "Israel", code: "IL", value: "Israel" },
  { text: "Italy", code: "IT", value: "Italy" },
  { text: "Japan", code: "JP", value: "Japan" },
  { text: "Kuwait", code: "KW", value: "Kuwait" },
  { text: "Lithuania", code: "LT", value: "Lithuania" },
  { text: "Luxembourg", code: "LU", value: "Luxembourg" },
  { text: "Malaysia", code: "MY", value: "Malaysia" },
  { text: "Netherlands", code: "NL", value: "Netherlands" },
  { text: "New Zealand", code: "NZ", value: "New Zealand" },
  { text: "Norway", code: "NO", value: "Norway" },
  { text: "Philippines", code: "PH", value: "Philippines" },
  { text: "Poland", code: "PL", value: "Poland" },
  { text: "Portugal", code: "PT", value: "Portugal" },
  { text: "Romania", code: "RO", value: "Romania" },
  { text: "Saudi Arabia", code: "SA", value: "Saudi Arabia" },
  { text: "South Korea", code: "KR", value: "South Korea" },
  { text: "Spain", code: "ES", value: "Spain" },
  { text: "Sweden", code: "SE", value: "Sweden" },
  { text: "Switzerland", code: "CH", value: "Switzerland" },
  { text: "Taiwan", code: "TW", value: "Taiwan" },
  { text: "Thailand", code: "TH", value: "Thailand" },
  { text: "Ukraine", code: "UA", value: "Ukraine" },
  { text: "United Kingdom", code: "GB", value: "United Kingdom" },
  { text: "United States", code: "US", value: "United States" },
];

// Layout
const midSummerLotteryLayoutEl = document.querySelector(
  ".js-midsummer-lottery",
);

// const mlLayoutUpdate = (layout) => {
//   // Space
//   // let heightSpace = 0;
//   // Top bg height
//   // const topBgHeight = layout.querySelector(
//   //   ".midsummer-lottery__bg-top",
//   // ).clientHeight;
//   // Bottom bg height
//   // const bottomBgHeight = layout.querySelector(
//   //   ".midsummer-lottery__bg-bottom",
//   // ).clientHeight;
//   // Space settings
//   // heightSpace = topBgHeight + bottomBgHeight + spacing;
//   // Add dynamic height
//   // layout.style.minHeight = `${heightSpace}px`;
//   const layoutBottomEl = layout.querySelector(".js-bottom-layout");
//   // console.log(layoutBottomEl.clientHeight);
// };

// const mediaQuery = window.matchMedia("(min-width: 768px)");
//
// function handleResize() {
//   if (mediaQuery.matches) {
//     if (midSummerLotteryLayoutEl) {
//       // mlLayoutUpdate(midSummerLotteryLayoutEl);
//     }
//   } else {
//     try {
//       midSummerLotteryLayoutEl.removeAttribute("style");
//     } catch (err) {
//       console.log(err);
//     }
//   }
// }
//
// handleResize();
//
// window.addEventListener("resize", handleResize);

// Form
let midsummerLotterySelectCountry = null;
if (document.querySelector(".js-midsummer-select")) {
  midsummerLotterySelectCountry = new SlimSelect({
    select: ".js-midsummer-select",
    settings: {
      placeholderText: "Choose country",
      showSearch: true,
      searchText: "Country not found",
      searchPlaceholder: "Search country",
      searchHighlight: true,
    },
    data: [],
  });
  midsummerLotterySelectCountry.setData(allCountry);
}

// Stepper
const stepper = document.querySelector(".js-stepper");
// Stepper loader
const stepperLoader = document.querySelector(".js-stepper__loader");
// Stepper active index
let stepperActiveIndex = 0;

// Phone number validate
const isValidPhoneNumber = (phoneNumber) => {
  let phoneValidStatus = false;
  const phoneRegex = /^\+?[0-9\s\-()]+$/;

  if (phoneNumber.value.length !== 0) {
    phoneValidStatus = phoneRegex.test(phoneNumber.value);
    phoneNumber
      .closest(".js-error-wraper")
      .querySelector(".form__error-message").textContent =
      "Phone number is invalid";
  } else {
    phoneNumber
      .closest(".js-error-wraper")
      .querySelector(".form__error-message").textContent =
      "This field is required.";
  }
  return phoneValidStatus;
};

// Email validate
const isValidEmail = (email) => {
  let emailalidStatus = false;
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  if (email.value.length !== 0) {
    emailalidStatus = emailRegex.test(email.value);
    email
      .closest(".js-error-wraper")
      .querySelector(".form__error-message").textContent = "Email is invalid";
  } else {
    email
      .closest(".js-error-wraper")
      .querySelector(".form__error-message").textContent =
      "This field is required.";
  }
  return emailalidStatus;
};

// Form check validate
const formValidation = (validateStep) => {
  let stepValidateStatus = false;
  const inputs = validateStep.querySelectorAll(
    "input[required], select[required]",
  );
  const invalidInputs = [];

  Array.from(inputs).forEach((input) => {
    let stateInput = true;

    if (input.tagName.toLowerCase() === "select") {
      stateInput =
        midsummerLotterySelectCountry.getSelected()[0] === "Choose country";
    } else {
      if (input.type === "email") {
        stateInput = !isValidEmail(input);
      } else if (input.type === "tel") {
        stateInput = !isValidPhoneNumber(input);
      } else {
        stateInput = !input.checkValidity();
      }
    }

    if (stateInput) {
      invalidInputs.push(input);
    }
  });

  Array.from(inputs).forEach((input) => {
    input
      .closest(".js-error-wraper")
      .querySelector(".form__error-message")
      .classList.remove("show");
  });

  if (invalidInputs.length > 0) {
    invalidInputs.forEach((input) => {
      input
        .closest(".js-error-wraper")
        .querySelector(".form__error-message")
        .classList.add("show");
    });

    // All is not valid
    stepValidateStatus = false;
  } else {
    stepValidateStatus = true;
  }

  return stepValidateStatus;
};

// Stepper loader
const stepperLoaderState = (state, loaderEl, stepper) => {
  const stepperWrapper = stepper.querySelector(".stepper__wrapper");

  if (state) {
    loaderEl.removeAttribute("style");
    stepperWrapper.style.display = "none";
  } else {
    loaderEl.style.display = "none";
    stepperWrapper.removeAttribute("style");
  }

  const stepperTop = stepper.getBoundingClientRect();
  const absoluteStepperTop = stepperTop.top + window.pageYOffset;
  const stepperScrollToY = absoluteStepperTop - 74;

  window.scrollTo({
    top: stepperScrollToY,
    behavior: "smooth",
  });
};

// Stepper next step
const stepperNext = (stepperEl) => {
  stepperActiveIndex++;

  // Step 1
  if (stepperActiveIndex !== 2) {
    stepperEl.querySelectorAll(".stepper__step").forEach((step) => {
      step.style.display = "none";
    });

    stepperEl
      .querySelectorAll(".stepper__step")
      [stepperActiveIndex].removeAttribute("style");

    stepperEl.querySelector(".js-button-next").textContent =
      stepperEl.querySelectorAll(".stepper__step")[
        stepperActiveIndex
      ].dataset.buttonNext;

    // Close loader
    stepperLoaderState(false, stepperLoader, stepper);
  }

  // Step 2
  if (stepperActiveIndex === 2) {
    let dataForm = {
      first_name: document.querySelector("input[name=first_name]").value,
      last_name: document.querySelector("input[name=last_name]").value,
      shop_name: document.querySelector("input[name=shop_name]").value,
      country: midsummerLotterySelectCountry.getSelected()[0],
      address: document.querySelector("input[name=address]").value,
      city: document.querySelector("input[name=city]").value,
      zip_code: document.querySelector("input[name=zip_code]").value,
      telephone: document.querySelector("input[name=telephone]").value,
      email: document.querySelector("input[name=email]").value,
      question1: document.querySelector("input[name=question1]").value,
      question2: document.querySelector("input[name=question2]").value,
      question3: document.querySelector("input[name=question3]").value,
    };

    axios.post(
        `${url}/competition/submit-form`,
        JSON.parse(JSON.stringify(dataForm)),
        {
          headers: {
            "X-CSRF-TOKEN": document.querySelector("input[name=csrf_token]")
              .value,
          },
        },
      )
      .then((response) => {
        console.log("Data sent successfully!", response);
        // Hide all steps
        stepperEl.querySelectorAll(".stepper__step").forEach((step) => {
          step.style.display = "none";
        });

        // Show active step
        stepperEl
          .querySelectorAll(".stepper__step")
          [stepperActiveIndex].removeAttribute("style");

        // Remove global error message
        document
          .querySelector(".form__error-message--form")
          .classList.remove("show");

        // Remove footer stepper
        stepperEl.querySelector(".js-stepper__footer").style.display = "none";

        // Close loader
        stepperLoaderState(false, stepperLoader, stepper);
        console.log(response, "Data sent successfully!");
      })
      .catch((error) => {
        // Show global error message
        document
          .querySelector(".form__error-message--form")
          .classList.add("show");

        // Close loader
        stepperLoaderState(false, stepperLoader, stepper);
        console.error("An error occurred while sending data:", error);
      });
  }
};

if (stepper) {
  const stepperCta = stepper.querySelectorAll(".js-button-next");

  stepperCta.forEach((cta) => {
    cta.addEventListener("click", (e) => {
     
        // Validation
        const stepperValid = formValidation(
          stepper.querySelectorAll(".stepper__step")[stepperActiveIndex],
        );
    
        // Call loader
        stepperLoaderState(true, stepperLoader, stepper);
    
        if (stepperValid) {
          setTimeout(() => {
            // Next step
            stepperNext(stepper);
          }, 2000);
        } else {
          setTimeout(() => {
            // Close loader
            stepperLoaderState(false, stepperLoader, stepper);
          }, 1000);
        }
      });

  });
}
